import React from 'react';
import { Link } from 'react-router-dom';
import {
  Box,
  Typography,
  Container,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import {
  CheckCircle,
  QrCode2,
  Business,
  Analytics,
  Share,
} from '@mui/icons-material';

const AuthLayout = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const features = [
    {
      icon: <QrCode2 />,
      text: 'Código QR personalizable',
    },
    {
      icon: <Business />,
      text: 'Diseño profesional',
    },
    {
      icon: <Analytics />,
      text: 'Analytics en tiempo real',
    },
    {
      icon: <Share />,
      text: 'Fácil de compartir',
    },
  ];

  if (isMobile) {
    // Mobile layout - only show form
    return (
      <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
        {children}
      </Box>
    );
  }

  // Desktop layout - two columns
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex' }}>
      {/* Left side - Branding/Hero */}
      <Box
        sx={{
          flex: 1,
          background: 'linear-gradient(135deg, #3b82f6, #1e40af)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          p: 6,
          color: 'white',
        }}
      >
        <Box sx={{ maxWidth: 400, textAlign: 'center' }}>
          <Typography
            variant="h2"
            sx={{
              fontWeight: 700,
              mb: 3,
              fontSize: '3rem',
            }}
          >
            CardQr
          </Typography>
          
          <Typography
            variant="h5"
            sx={{
              mb: 4,
              opacity: 0.9,
              lineHeight: 1.6,
            }}
          >
            Crea tarjetas de presentación digitales modernas y elegantes
          </Typography>
          
          {/* Features list */}
          <List sx={{ textAlign: 'left' }}>
            {features.map((feature, index) => (
              <ListItem key={index} sx={{ py: 1 }}>
                <ListItemIcon sx={{ minWidth: 40 }}>
                  <Box
                    sx={{
                      width: 32,
                      height: 32,
                      borderRadius: '50%',
                      bgcolor: 'rgba(255, 255, 255, 0.2)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'white',
                    }}
                  >
                    {React.cloneElement(feature.icon, { fontSize: 'small' })}
                  </Box>
                </ListItemIcon>
                <ListItemText
                  primary={feature.text}
                  primaryTypographyProps={{
                    color: 'white',
                    sx: { opacity: 0.9 },
                  }}
                />
              </ListItem>
            ))}
          </List>

          {/* Footer */}
          <Box sx={{ mt: 6, pt: 4, borderTop: '1px solid rgba(255, 255, 255, 0.2)' }}>
            <Typography variant="body2" sx={{ opacity: 0.7 }}>
              © 2024 CardQr. Transformando el networking profesional.
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* Right side - Form */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: 'background.default',
          p: 3,
        }}
      >
        <Box sx={{ width: '100%', maxWidth: 500 }}>
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default AuthLayout; 